import {expressApi} from '@/api/axiosClients';

export async function getTallyVotes(params) {
  try {
    const result = await expressApi.get(`/v1/tally/votes`, {params});
    if (!result.status || result.status !== 200) {
      throw new Error('Server Error');
    }
    if (result.data.error) {
      throw new Error(result.data.message || 'Unknown Error');
    }
    return result.data;
  }
  catch (e) {
    console.error(e);
  }
}
